import { Sprite, Texture } from 'pixi.js';
import { InteractionEvents } from '@cc/pixi-app';
import { ScreenBase } from './ScreenBase';
import { avatarGenerator } from '../common/AvatarGenerator';
import { PartCarousel } from './../avatarCreator/partCarousel';
import { ButtonBase } from './../common/ButtonBase';
import avatarConfig from "../../data/avatar-config.json";
import { ColorWheel } from './../avatarCreator/colorWheel';
import { storageManager } from './../common/StorageManager';
import { EventEmitter } from '../../../node_modules/eventemitter3';
import { dataImporter } from './../DataImporter';


export class ScreenAvatarCreator extends ScreenBase {

    init(){
        this.out = true;

        this.ee = new EventEmitter();

        this.app.sound.play("01-main-menu");

        this.background = new Sprite.from('hills_bg');
        this.background.height = this.app.resizer.height;
        this.background.scale.x = this.background.scale.y;
        this.background.anchor.set(0.5);
        this.addChild(this.background);

        this.ui.addChild(this.createMuteButton('TopRight'));

        this.avatarShadow = new Sprite.from("avatar_shadow");
        this.addChild(this.avatarShadow);
        this.avatarShadow.position.set(0,350);
        this.avatarShadow.anchor.set(0.5);
        this.avatarShadow.scale.set(1.25);
        this.avatar = avatarGenerator.getAnimation("avatar-front-anim", "front", false);
        this.avatar.position.set(0, 350);
        this.avatar.scale.set(1.25);
        this.addChild(this.avatar);

        if (storageManager.data.dna === null){
            this.createCustomizationScreen();
        }
        else{
            this.createSelectScreen();
        }
    }

    createSelectScreen(){

        this.customButton = new ButtonBase(new Texture.from("customize-button"));
        this.customButton.anchor.set(0.5);
        this.customButton.once(InteractionEvents.PointerTap, ()=> {
            this.app.sound.play("02-ui-click");
            this.tickButton.off(InteractionEvents.PointerTap);
            this.openFaceCustomization();
        });
        this.addChild(this.customButton);
        this.customButton.y = 575;
        this.tickButton = new ButtonBase(new Texture.from("tick-btn"));
        this.tickButton.position.set(550, 450);
        this.addChild(this.tickButton);
        this.tickButton.once(InteractionEvents.PointerTap, ()=> {
            this.app.sound.play("02-ui-click");
            this.app.showScreen('packs');
        });
    }

    createCustomizationScreen(){
        this.tickButton = new ButtonBase(new Texture.from("tick-btn"));
        this.tickButton.position.set(550, 450);
        this.addChild(this.tickButton);

        this.openFaceCustomization();
    }

    openFaceCustomization(){
        this.ee.removeAllListeners();
        this.createColorWheel("skin");
        this.removeChild(this.customButton);
        this.tickButton.once(InteractionEvents.PointerTap, ()=> {
            this.app.sound.play("02-ui-click");
            this.openBodyCustomisation();
        });
        this.hairPanel = new PartCarousel(
            [avatarConfig.parts.avatar_hair],
            -300, this,
            ["avatar_hair"],
            "hair",
            true
        );
        this.eyesPanel = new PartCarousel(
            [avatarConfig.parts.avatar_iris, avatarConfig.parts.avatar_eyes, avatarConfig.parts.avatar_eyes_blink, avatarConfig.parts.avatar_eyebrows],
            0, this,
            ["avatar_iris", "avatar_eyes", "avatar_eyes_blink", "avatar_eyebrows"],
            "eyes",
            true
        );
        this.facePanel = new PartCarousel(
            [avatarConfig.parts.avatar_nose, avatarConfig.parts.avatar_lips, avatarConfig.parts.avatar_teeth],
            300, this,
            ["avatar_nose", "avatar_lips", "avatar_teeth"],
            "skin",
            true
        );
        this.addChild(this.facePanel.container);
        this.addChild(this.hairPanel.container);
        this.addChild(this.eyesPanel.container);
        this.addChild(this.colorWheel.wheel);
        this.tickButton.visible = false;
        this.moveCharacter(3.5,1825,500,750);
        this.hairPanel.setActiveState(this.hairPanel);
    }

    openBodyCustomisation(){
        this.ee.removeAllListeners();
        this.tickButton.once(InteractionEvents.PointerTap, ()=> {
            this.app.sound.play("02-ui-click");
            this.app.showScreen('packs');
        });
        this.removeChild(this.hairPanel.container);
        this.removeChild(this.eyesPanel.container);
        this.removeChild(this.facePanel.container);
        this.removeChild(this.colorWheel.wheel);
        this.moveCharacter(1.75,600,0,750);

        this.topPanel = new PartCarousel(
            [avatarConfig.parts.outfit_arm_right, avatarConfig.parts.outfit_arm_left, avatarConfig.parts.outfit_body],
            -300, this,
            ["outfit_arm_right", "outfit_arm_left", "outfit_body"]
        );
        this.trouserPanel = new PartCarousel(
            [avatarConfig.parts.outfit_leg_right, avatarConfig.parts.outfit_leg_left, avatarConfig.parts.outfit_waist],
            0, this,
            ["outfit_leg_right", "outfit_leg_left", "outfit_waist"]
        );
        this.shoesPanel = new PartCarousel(
            [avatarConfig.parts.outfit_foot_right, avatarConfig.parts.outfit_foot_left],
            300, this,
            ["outfit_foot_right", "outfit_foot_left"]
        );
        this.addChild(this.topPanel.container);
        this.addChild(this.trouserPanel.container);
        this.addChild(this.shoesPanel.container);
        this.topPanel.setActiveState(this.topPanel);
    }

    closeCustomisationScreen(){
        this.removeChild(this.topPanel.container);
        this.removeChild(this.trouserPanel.container);
        this.removeChild(this.shoesPanel.container);
        this.moveCharacter(1.25,450,250,750);

        this.customButton = new ButtonBase(new Texture.from("customize-button"));
        this.customButton.anchor.set(0.5);
        this.customButton.once(InteractionEvents.PointerTap, ()=> {
            this.app.sound.play("02-ui-click");
            this.openFaceCustomization();
        });
        this.addChild(this.customButton);
        this.customButton.y = 575;
        this.tickButton.once(InteractionEvents.PointerTap, ()=> {
            this.app.sound.play("02-ui-click");
            this.app.showScreen('packs');
        });
        this.out = true;
    }

    createColorWheel(colors){
        this.colorWheel = new ColorWheel(colors, this);
        this.colorWheel.wheel.y = 350;
    }

    moveCharacter(scale, y, delay, speed){
        this.tween(this.avatar)
            .wait(delay)
            .to({y: y}, speed, createjs.Ease.getElasticIn(1.1, 1.5));
        this.tween(this.avatar.scale)
            .wait(delay)
            .to({x: scale, y:scale}, speed, createjs.Ease.getElasticIn(1.1, 1.5));
        this.tween(this.avatarShadow)
            .wait(delay)
            .to({y: y}, speed, createjs.Ease.getElasticIn(1.1, 1.5));
        this.tween(this.avatarShadow.scale)
            .wait(delay)
            .to({x: scale, y:scale}, speed, createjs.Ease.getElasticIn(1.1, 1.5));
    }

    onColorSelect(){
        if (this.out){
            this.facePanel.animateArrowsIn();
            this.eyesPanel.animateArrowsIn();
            this.hairPanel.animateArrowsIn();
            this.hairPanel.setColourWheel();
            this.tickButton.visible = true;
            this.out = false;
        }
    }

    onCarouselSelected(carousel){
        this.ee.emit("carousel:selected", carousel);
    }
}
